module.exports = function(logs) {
	'use strict'
	logs.directive('singleLog',singleLog);
	singleLog.$inject=[];
	function singleLog() {
		return {
			template: require('./partials/single-log.html'),
			scope: {
		      obj:"="
		    },
			link: function(scope, element, attrs, ctrl) {	    
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/logsModule/js/directive/singleLogDirective.js
// module id = 507
// module chunks = 0